import Header from './components/Header';
import Hero from './components/Hero';
import ZeroBrokerage from './components/ZeroBrokerage';
import MarginSection from './components/MarginSection';
import OpenAccount from './components/OpenAccount';
import BlogCards from './components/BlogCards';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import WebTraderSection from './components/WebTraderSection';
import PaymentUpdate from './components/PaymentUpdate';
import BlogHeader from './components/BlogHeader';

function Home() {
  return (
    <div className="app">
      <Header />
      <Hero />
      <ZeroBrokerage />
      <MarginSection />
      <OpenAccount />
      <WebTraderSection />
      <PaymentUpdate />
      <BlogHeader />
      <BlogCards />
      <Footer />
      <ChatWidget />
    </div>
  );
}

export default Home;
